import Pure from './pure';
//import Handlers from 'handlers';

const FaqGroup = Pure;

export default FaqGroup;
